import { Typography } from "components";

const ErrorText: React.FC<React.PropsWithChildren> = ({ children }) => (
  <Typography
    size={-1}
    color="#c62828"
    style={{
      background: "#ffebee",
      border: "solid 1px #ffcdd2",
      padding: "12px 14px",
      borderRadius: "8px",
    }}
  >
    {children}
  </Typography>
);

export { ErrorText };
